module.exports = __webpack_public_path__ + "static/media/bpbg-2022-7.56050015.gif";